import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {InvoiceAddressState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class InvoiceAddressQuery extends QueryEntity<InvoiceAddressState> {

  constructor(protected store: Store) {
    super(store);
  }

}
